import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray, createForOfIteratorHelper as _createForOfIteratorHelper } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { defaultMemoize } from 'reselect';
import emojiRegex from 'emoji-regex';
import { XMLParser } from 'fast-xml-parser';

var REGEXP_SPEC_BOLD = "\\*([^\\*\\n]+)?\\*";
var REGEXP_SPEC_ITALIC = "_([^_\\n]+)?_";
var REGEXP_SPEC_INLINE_CODE = "`([^`\\n]+?)`";
var REGEXP_SPEC_CODE_BLOCK = "`{3}([^]+?)`{3}";
var REGEXP_SPEC_LINK = "<((https|http)?:?//(|[^]+?.)[^]+?.[^]+?)(|\\|([^]+?))>";
var REGEXP_MENTION = "<(@|#)([^>]+?)(|:([^>]+?))>";
var REGEXP_ATTR = "(<[/\n\r]*attr[^>]*>)";
var MARK_TEXT_REGEX = "<mark ([^>:]+?)>";
var HIGHLIGHTED_TEXT_REGEX = "<highlighted ([^>:]+?)>";
var REGEXP_EMOJI = "(:[^: \n]+?:)";
var REGEXP_NATIVE_EMOJI = "(".concat(emojiRegex().source, ")");
var xmlParser = new XMLParser({
  allowBooleanAttributes: true,
  ignoreAttributes: false
});
var getMentionType = function getMentionType(type) {
  switch (type) {
    case "#":
      return "channel";
    case "@":
      return "user";
  }
};
var regexTokenizer = function regexTokenizer(originText) {
  var _a, _b, _c, _d, _e, _f, _g;
  var ALL_REGEXP = new RegExp([REGEXP_ATTR, REGEXP_SPEC_LINK, REGEXP_SPEC_BOLD, REGEXP_SPEC_ITALIC, REGEXP_SPEC_INLINE_CODE, REGEXP_SPEC_CODE_BLOCK, REGEXP_MENTION, MARK_TEXT_REGEX, HIGHLIGHTED_TEXT_REGEX, REGEXP_EMOJI, REGEXP_NATIVE_EMOJI].join("|"), "g");
  var tokens = [];
  var attrTagShard = [];
  var match = null;
  while ((match = ALL_REGEXP.exec(originText)) !== null) {
    var _match = match,
      _match2 = _slicedToArray(_match, 19),
      matchText = _match2[0],
      attrTag = _match2[1],
      linkUrl = _match2[2],
      linkDisplay = _match2[6],
      boldValue = _match2[7],
      italicValue = _match2[8],
      inlineCodeValue = _match2[9],
      codeBlockValue = _match2[10],
      mentionType = _match2[11],
      mentionUrl = _match2[12],
      mentionDisplay = _match2[14],
      markedText = _match2[15],
      highlightedText = _match2[16],
      emoji = _match2[17],
      nativeEmoji = _match2[18];
    var offset = match.index;
    var length = matchText.trim().length;
    if (attrTagShard.length > 0 && !attrTag) {
      continue;
    }
    if (linkUrl) {
      var _ref = linkDisplay ? linkDisplay.split("|") : [""],
        _ref2 = _slicedToArray(_ref, 2),
        displayText = _ref2[0],
        isPreview = _ref2[1];
      var href = linkUrl;
      if (linkUrl.substring(0, 2) === "//") {
        href = linkUrl.substring(2);
      }
      tokens.push({
        offset: offset,
        length: length,
        type: "link",
        origin: matchText,
        data: {
          href: href,
          value: displayText ? displayText : href,
          isPreview: Boolean(isPreview && isPreview === "true")
        }
      });
    } else if (mentionType && mentionUrl && mentionDisplay) {
      var mentionIdData = mentionUrl.split("|");
      tokens.push({
        offset: offset,
        length: length,
        type: "mention",
        origin: matchText,
        data: {
          display: mentionDisplay,
          id: mentionIdData[0],
          fallback: mentionIdData[1],
          type: getMentionType(mentionType)
        }
      });
    } else if (boldValue && boldValue.trim()) {
      tokens.push({
        offset: offset,
        length: length,
        type: "bold",
        origin: matchText,
        data: {
          value: boldValue,
          innerStyles: parser(boldValue)
        }
      });
    } else if (italicValue && italicValue.trim()) {
      tokens.push({
        offset: offset,
        length: length,
        type: "italic",
        origin: matchText,
        data: {
          value: italicValue,
          innerStyles: parser(italicValue)
        }
      });
    } else if (inlineCodeValue) {
      tokens.push({
        offset: offset,
        length: length,
        type: "inlineCode",
        origin: matchText,
        data: {
          value: inlineCodeValue,
          innerStyles: parser(inlineCodeValue)
        }
      });
    } else if (codeBlockValue) {
      tokens.push({
        offset: offset,
        length: length,
        type: "codeBlock",
        origin: matchText,
        data: {
          value: codeBlockValue,
          innerStyles: parser(codeBlockValue)
        }
      });
    } else if (emoji) {
      tokens.push({
        offset: offset,
        length: length,
        type: "emoji",
        origin: matchText,
        data: {
          value: emoji,
          innerStyles: []
        }
      });
    } else if (nativeEmoji) {
      tokens.push({
        offset: offset,
        length: length,
        origin: matchText,
        type: "nativeEmoji",
        data: {
          value: nativeEmoji,
          innerStyles: []
        }
      });
    } else if (markedText) {
      tokens.push({
        offset: offset,
        length: length,
        origin: matchText,
        type: "mark",
        data: {
          value: markedText,
          innerStyles: parser(inlineCodeValue)
        }
      });
    } else if (highlightedText) {
      tokens.push({
        offset: offset,
        length: length,
        origin: matchText,
        type: "highlight",
        data: {
          value: highlightedText,
          innerStyles: parser(inlineCodeValue)
        }
      });
    } else if (attrTag) {
      /**
       * NOTE: parser 에선 중첩된 경우를 허용하고 있습니다.
       * delta -> moim-down 으로 변환할때는 중첩되지 않게 해주세요.
       */
      if (attrTag.startsWith("</")) {
        var prevShard = attrTagShard.pop();
        if (prevShard) {
          var innerValue = originText.substring(prevShard.offset + prevShard.length, match.index);
          var fullText = "".concat(prevShard.matchText).concat(innerValue).concat(matchText);
          var parsedXml = xmlParser.parse(fullText);
          var payload = {
            offset: prevShard.offset,
            length: prevShard.length + innerValue.length + matchText.length,
            origin: fullText,
            type: "attr",
            data: {
              value: innerValue,
              innerStyles: prevShard.innerStyles,
              properties: {
                "font-color": (_a = parsedXml.attr) === null || _a === void 0 ? void 0 : _a["@_fc"],
                "background-color": (_b = parsedXml.attr) === null || _b === void 0 ? void 0 : _b["@_bc"],
                "font-weight": (_c = parsedXml.attr) === null || _c === void 0 ? void 0 : _c["@_fw"],
                "font-size": (_d = parsedXml.attr) === null || _d === void 0 ? void 0 : _d["@_fs"],
                italic: (_e = parsedXml.attr) === null || _e === void 0 ? void 0 : _e["@_i"],
                code: (_f = parsedXml.attr) === null || _f === void 0 ? void 0 : _f["@_c"]
              }
            }
          };
          if (attrTagShard.length === 0) {
            payload.data.innerStyles = parser(payload.data.value);
            tokens.push(payload);
          } else {
            if (attrTagShard[attrTagShard.length - 1].innerStyles) {
              (_g = attrTagShard[attrTagShard.length - 1].innerStyles) === null || _g === void 0 ? void 0 : _g.push(payload);
            } else {
              attrTagShard[attrTagShard.length - 1].innerStyles = [payload];
            }
          }
        }
      } else {
        attrTagShard.push({
          offset: offset,
          length: matchText.length,
          matchText: matchText
        });
      }
    }
  }
  return tokens;
};
var plainTextTokenizer = function plainTextTokenizer(originalText, styleEntityTokens) {
  var tokens = _toConsumableArray(styleEntityTokens);
  var pivot = 0;
  var _iterator = _createForOfIteratorHelper(styleEntityTokens),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var styleEntityToken = _step.value;
      var _text = originalText.slice(pivot, styleEntityToken.offset);
      if (_text) {
        tokens.push({
          offset: pivot,
          length: _text.length,
          type: "text",
          data: {
            value: _text
          }
        });
      }
      pivot = styleEntityToken.offset + styleEntityToken.length;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (pivot !== originalText.length) {
    var text = originalText.slice(pivot, originalText.length);
    tokens.push({
      offset: pivot,
      length: text.length,
      type: "text",
      data: {
        value: text
      }
    });
  }
  return tokens;
};
var reorderTokens = function reorderTokens(tokens) {
  return tokens.sort(function (a, b) {
    return a.offset < b.offset ? -1 : a.offset > b.offset ? 1 : a.length < b.length ? -1 : a.length > b.length ? 1 : 0;
  });
};
var parser = defaultMemoize(function (text) {
  if (!text) {
    return [{
      offset: 0,
      length: 0,
      type: "text",
      data: {
        value: ""
      }
    }];
  }
  var regexTokens = regexTokenizer(text);
  var tokens = plainTextTokenizer(text, regexTokens);
  return reorderTokens(tokens);
});

export { HIGHLIGHTED_TEXT_REGEX, MARK_TEXT_REGEX, REGEXP_EMOJI, REGEXP_NATIVE_EMOJI, parser, plainTextTokenizer, regexTokenizer, reorderTokens };
